import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';

import './styles.css';
import MapGraphic from '../img/refer-prof-holding-map-graphic.svg';

const ReferPage = props => {
  return (
    <EducationModuleLayout
      progressStage={1}
      childTitle="Refer"
      progressType="refer"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <h2 className="txt-blue no-bold no-margin">REFER: What Makes an Effective Referral</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <img
                className="img-block img-responsive"
                src={MapGraphic}
                alt="Graphic of student holding a map"
              />
              <p>
                Once you’ve identified and held an assistive conversation with someone experiencing a mental health challenge,
                the next step would be to make effective referrals. To guide the Refer process,
                we will be reviewing <strong>four components</strong> that you can use to connect
                someone with available and preferred resources and services. These components include:
              </p>
              <ol style={{ fontWeight: "bold" }}>
                <li>Acknowledge limitations</li>
                <li>Share resources and services</li>
                <li>Explain</li>
                <li>Follow up</li>
              </ol>
              <p>
                A list of resources and services that promote and support mental health for the U of T
                community will be shared at the end of this section.
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <section>
        <div className="container text-center">
          <Row>
            <Col xs={12}>
              <Button
                className="btn btn-blue previous"
                onClick={() => props.history.goBack()}
              >
                Previous
              </Button>
              <LinkContainer to={url.REFER_B} className="btn btn-blue next">
                <Button>Next</Button>
              </LinkContainer>
            </Col>
          </Row>
        </div>
      </section>
    </EducationModuleLayout>
  );
};

ReferPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const ReferA = connect.role(ReferPage);

export default ReferA;



// WEBPACK FOOTER //
// ./src/containers/Refer/ReferA/index.jsx